import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { companyApi, type Company } from "./companyApi";

export const companiesQueryKey = ["companies"] as const;

export function useCompaniesQuery() {
  return useQuery<Company[], Error>({
    queryKey: companiesQueryKey,
    queryFn: () => companyApi.getAllCompanies(),
    // staleTime: 5 * 60 * 1000,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
    placeholderData: keepPreviousData,
  });
}